import Box from "ds/components/Box";
import Link from "ds/components/Link";
import Badge from "ds/components/Badge";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps } from "../types";

type RolesListItemNameCellProps = CellComponentProps;

const RolesListItemNameCell = ({ role }: RolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${role.id}`;

  return (
    <Box align="center" fullWidth gap="large">
      <Link
        analyticsPage={AnalyticsPageOrganization.OrganizationRoles}
        analyticsTitle="Role Name Clicked"
        analyticsProps={{
          roleName: role.name,
        }}
        size="small"
        variant="secondary"
        href={roleUrl}
      >
        {role.name}
      </Link>

      {role.isSystem && <Badge type="strong" variant="blue" text="SYSTEM" />}
    </Box>
  );
};

export default RolesListItemNameCell;
